// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { generateId } from '../_common/api/utility';
import Cart from '../_common/Cart';
import Button from '../_common/form/Button';
import Icon from '../_common/form/Icon';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import MenuButton from '../_common/MenuButton';
import MenuRoutes from './MenuRoutes';

const Wrapper = styled.div`
    height: 100%;
    width: ${({ open }) => open ? '75%' : 0};
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.mobile.menu};
    overflow-x: hidden;
    transition: all 300ms cubic-bezier(.62, .04, .3, 1.56);
    transition-delay: 100ms;
    display: flex;
    justify-content: center;
`
const InnerWrap = styled.div`
    height: 100%;
    width: ${({ open }) => open ? '75%' : 0};
    position: fixed;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.mobile.menu}80;
    overflow-x: hidden;
    transition: all 200ms cubic-bezier(.62, .04, .3, 1.8);
    transition-delay: 50ms;
`
const Content = styled.div`
    position: relative;
    width: 70%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
    text-align: center;
    margin: 10vh 0;
`
const ScreenWrap = styled.div`
    height: 100%;
    width: ${({ open }) => open ? '100%' : 0};
    opacity: ${({ open }) => open ? 1 : 0};
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.secondary}80;
    overflow-x: hidden;
    transition: all 200ms ease-in-out;
`

const slideIn = styled(MenuButton)`
    opacity: 0;
    ${({ open, delay }) => open ? `
    animation: slideInFromLeftFadeIn;
    animation-delay: ${0.2 + ((delay + 1) / 50)}s;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
    ` : null}
`
const CartItem = styled(slideIn)`
    text-decoration: none;
    display: flex;
    align-items: center;
`;
const Item = styled(slideIn)`
    width: 100%;
    text-align: initial;
`;
const CloseButton = styled(Icon)`
    position: absolute;
    top: 3%;
    right: 10%;
`;
const Notif = styled.div`
    position: absolute;
    top: -0.5em;

    font-size: 0.7rem;

    color: ${({ theme }) => theme.mobile.white};
    border-radius: 50%;
    background-color: red;
    line-height: 1rem;
    width: 0.5em;
    height: 0.5em;
`;

const Menu = ({ isOpen, setIsOpen, children, ...props }) => {
    const {
        state: {
            active_user,
        },
        logOut
    } = useGlobalState();

    useEffect(() => {
        let posX1 = 0, posX2 = 0;

        function touchStart(e) {
            e = e || window.event;
            posX1 = e.changedTouches[0].clientX;
            const draggables = document.querySelector('[data-draggable="true"]');
            if (draggables) return;
            window.ontouchend = touchEnd;
            window.ontouchmove = touchDrag;
        }

        function touchDrag(e) {
            e = e || window.event;
            posX2 = e.changedTouches[0].clientX;
        }

        function touchEnd() {
            window.ontouchend = null;
            window.ontouchmove = null;

            if (!isOpen) setIsOpen(posX2 - posX1 > (window.screen.width * 0.5))
            posX1 = null
            posX2 = null
        }

        const dragOpen = () => touchStart()
        window.addEventListener('touchstart', dragOpen);
        return () => window.removeEventListener('touchstart', dragOpen);
    })

    const routes = MenuRoutes();

    const appMenu = Object
        .entries(routes)
        .map(([key, value]) => value)
        .filter(e => e.menuItem === true)
        .sort((a, b) => a.order - b.order);

    return (
        <>
            <Wrapper open={isOpen}>
                {/* <CloseButton icon='cross' /> */}
                <InnerWrap open={isOpen} onClick={() => setIsOpen(false)} />
                <Content onClick={() => setIsOpen(false)}>
                    {
                        active_user.isGuestUser ?
                            <>
                                {
                                    appMenu
                                        .filter(e => e.isGuestUser)
                                        .filter(e => !e.disabled)
                                        .map((e, i) =>
                                            <Item
                                                key={generateId()}
                                                to={e.route}
                                                label={e.label}
                                                icon={e.icon}
                                                delay={i}
                                                open={isOpen}
                                            />
                                        )
                                }
                            </> : null
                    }
                    {
                        active_user.isLoggedIn ?
                            <>
                                {
                                    appMenu
                                        .filter(e => !e.disabled)
                                        .map((e, i) => {
                                            return (
                                                <Item
                                                    key={generateId()}
                                                    to={e.route}
                                                    label={e.label}
                                                    icon={e.icon}
                                                    delay={i}
                                                    open={isOpen}
                                                >
                                                    {e.label === 'Notifications' && active_user.notifications?.unread ? <Notif /> : null}
                                                </Item>
                                            )
                                        }

                                        )
                                }
                                <CartItem
                                    to={'/checkout'}
                                    delay={appMenu.length}
                                    open={isOpen}
                                >
                                    <Cart label />
                                </CartItem>
                            </> :
                            null
                    }

                    <Button
                        style={{ width: '100%', whiteSpace: 'nowrap' }}
                        to='/logOut'
                        icon='powerOff'
                        onClick={() => {
                            logOut();
                            if (active_user.isLoggedIn) Cart.Empty();
                        }}
                    >{active_user.isGuestUser ? 'Log In' : 'Log Out'}</Button>
                </Content>
            </Wrapper>
            <ScreenWrap open={isOpen} onClick={() => setIsOpen(false)} />
        </>
    );
}

export default Menu;